module.exports = __webpack_public_path__ + "assets/img/data-monitoring-new.b17960a9.png";